import UserInfo from '@/lib/user-info'

export default class GrowCrop {
  constructor(crop) {
    this.masterId = crop.master_id
    this.name = crop.name
  }

  get localizedName() {
    const lang = UserInfo.getLanguage()
    const value = this.name[lang]
    if (value) {
      return value
    }
    return null
  }
}
